import { Outlet } from 'react-router-dom'
import MarketingSourceCapture from '@/components/marketingSourceCapture'

const PublicAuthLayout = () => {
  return (
    <>
      <MarketingSourceCapture />
      <Outlet />
    </>
  )
}

export default PublicAuthLayout
